import { Injectable } from "@angular/core";
import { type AbstractControl, FormControl, type FormGroup, FormBuilder, Validators } from "@angular/forms";
import type { StringOrNull } from "@core-interfaces/global";
import type { FormErrorMap } from "@core-ports/outputs/forms/base";
import { BaseFormFactory } from "@infra-adapters/forms/base";

export interface IChangePasswordFormInput {
    current_password: FormControl<StringOrNull>;
    new_password: FormControl<StringOrNull>;
    confirm_password: FormControl<StringOrNull>;
}

function passwordsMatchValidator(form: AbstractControl): { passwordsMismatch: true } | null {
    const group = form as FormGroup;
    const newPwd = group.get('new_password')?.value;
    const confirm = group.get('confirm_password')?.value;
    if (confirm && newPwd !== confirm) {
        group.get('confirm_password')?.setErrors({ passwordsMismatch: true });
        return { passwordsMismatch: true };
    }
    const existing = group.get('confirm_password')?.errors;
    if (existing?.['passwordsMismatch']) {
        group.get('confirm_password')?.setErrors(null);
    }
    return null;
}

@Injectable({ providedIn: 'root' })
export class ChangePasswordFormFactory extends BaseFormFactory<IChangePasswordFormInput> {

    constructor(private fb: FormBuilder) {
        super();
    }

    generateForm(): FormGroup<IChangePasswordFormInput> {
        return this.fb.group<IChangePasswordFormInput>({
            current_password: new FormControl<StringOrNull>(null, [Validators.required]),
            new_password: new FormControl<StringOrNull>(null, [Validators.required, Validators.minLength(8)]),
            confirm_password: new FormControl<StringOrNull>(null, [Validators.required]),
        }, { validators: passwordsMatchValidator });
    }

    protected getErrorMap(control: AbstractControl): FormErrorMap<IChangePasswordFormInput> {
        return {
            _default: {
                required: 'Este campo es obligatorio.',
                minlength: `Debe tener al menos ${control.errors?.['minlength']?.requiredLength} caracteres.`,
                passwordsMismatch: 'Las contraseñas no coinciden.',
            }
        };
    }
}
